(function () {
  document.querySelectorAll('[data-ca-pdf]').forEach(function (root) {
    var form = root.querySelector('[data-ca-pdf-form]');
    var input = root.querySelector('input[name="whatsapp"]');
    var error = root.querySelector('[data-ca-pdf-error]');
    var endpoint = root.getAttribute('data-endpoint');
    if (!form || !input) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var digits = (input.value || '').replace(/\D/g, '');

      if (digits.length < 10) {
        if (error) error.textContent = 'Please enter a valid 10-digit number.';
        input.focus();
        return;
      }
      if (error) error.textContent = '';

      // Optional lead capture: POST the number to the configured endpoint (e.g. Interakt).
      if (endpoint) {
        try {
          fetch(endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ whatsapp: digits, source: 'ca-hub-pdf', page: location.pathname })
          }).catch(function () {});
        } catch (err) {}
      }

      // Reveal the thank-you + download state.
      root.classList.add('is-done');
    });
  });
})();
